import React,{useState} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './utils/auth';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import LoginPage from './pages/LoginPage';
import LiveMonitoring from './pages/LiveMonitoring';
import Evidences from './pages/Evidences';
import Vehicles from './pages/Vehicles';
import Drivers from './pages/Drivers';
import LogPage from './pages/LogPage';
import DashboardLayout from './components/DashboardLayout';
import { IconButton } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  React.useEffect(() => {
    if (user) {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [user]);
  if (!user) return <Navigate to="/login" />;
  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#181818' }}>
        <svg width="80" height="80" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" stroke="#90caf9">
          <g fill="none" fillRule="evenodd">
            <g transform="translate(2 2)" strokeWidth="3">
              <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
              <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
              </path>
            </g>
          </g>
        </svg>
      </div>
    );
  }
  return children;
}

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#181818',
      paper: '#232323',
    },
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#f5f5f5',
      paper: '#fff',
    },
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

function App() {
  const [mode, setMode] = useState('dark');
  const theme = mode === 'dark' ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: 9999 }}>
        <IconButton
          color="inherit"
          onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
          aria-label="toggle theme"
        >
          {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
      </Box>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <DashboardLayout />
                </PrivateRoute>
              }
            >
              <Route path="live-monitoring" element={<LiveMonitoring />} />
              <Route path="evidences" element={<Evidences />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="drivers" element={<Drivers />} />
              <Route path="log" element={<LogPage />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
